<p-dialog
  [header]="'FreeswitchIntegration::ConsoleDialogTitle' | abpLocalization"
  [(visible)]="dialogVisible"
  [modal]="true"
  [style]="{ width: '60rem' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [maximizable]="true"
  (onHide)="onHide()"
  styleClass="freeswitch-instance-console"
  contentStyleClass="freeswitch-instance-console__content">
  <form [formGroup]="form" (ngSubmit)="execute()">
    <!-- The black area is the terminal: scrollback and the live prompt line share one scroll box, so
         the prompt sits directly under the last response the way a real console does. -->
    <div class="fs-console" (click)="focusInput()">
      <div class="fs-console__screen" #screen>
        <div class="fs-console__banner">
          <div>{{ 'FreeswitchIntegration::ConsoleDialogTitle' | abpLocalization }} [{{ instance?.name }}]</div>
          <div class="fs-console__banner-hint">{{ 'FreeswitchIntegration::ConsoleHint' | abpLocalization }}</div>
        </div>

        <div
          class="fs-console__empty"
          *ngIf="!hasEntries && !isBusy">{{ 'FreeswitchIntegration::ConsoleNoOutputYet' | abpLocalization }}</div>

        <ng-container *ngFor="let entry of entries; trackBy: trackByEntry">
          <div class="fs-console__line fs-console__line--command" *ngIf="entry.kind === 'command'">
            <span class="fs-console__prompt">{{ entry.prompt }}</span><span class="fs-console__typed">{{ entry.text }}</span>
          </div>

          <div
            class="fs-console__line fs-console__line--output"
            *ngIf="entry.kind === 'output'">{{ entry.text }}<span class="fs-console__duration" *ngIf="entry.durationMs !== undefined"> [{{ formatDuration(entry.durationMs) }}]</span></div>

          <div
            class="fs-console__line fs-console__line--error"
            *ngIf="entry.kind === 'error'">{{ entry.text }}</div>
        </ng-container>

        <div class="fs-console__line fs-console__line--busy" *ngIf="isBusy">
          {{ 'FreeswitchIntegration::ConsoleExecuting' | abpLocalization }}
        </div>

        <div class="fs-console__prompt-line" [class.fs-console__prompt-line--hidden]="isBusy">
          <label class="fs-console__prompt" for="command">{{ prompt }}</label>
          <input
            #commandInput
            id="command"
            type="text"
            class="fs-console__input"
            formControlName="command"
            [attr.aria-label]="'FreeswitchIntegration::ConsoleCommand' | abpLocalization"
            [attr.maxlength]="512"
            autocomplete="off"
            autocapitalize="off"
            spellcheck="false"
            (keydown)="onCommandKeydown($event)" />
        </div>
      </div>
    </div>
  </form>

  <div class="fs-console__presets">
    <span class="fs-console__presets-hint">{{ 'FreeswitchIntegration::ConsoleHistoryHint' | abpLocalization }}</span>
    <button
      *ngFor="let preset of presets; trackBy: trackByPreset"
      type="button"
      class="btn btn-sm btn-outline-secondary fs-console__preset"
      [disabled]="isBusy"
      (click)="applyPreset(preset)">
      {{ preset.command }}
    </button>
  </div>

  <ng-template #footer>
    <button
      type="button"
      class="btn btn-outline-secondary fs-console__clear-btn"
      [disabled]="isBusy || !hasEntries"
      [pTooltip]="'FreeswitchIntegration::ConsoleClearTooltip' | abpLocalization"
      tooltipPosition="top"
      (click)="clear()">
      {{ 'FreeswitchIntegration::ConsoleClear' | abpLocalization }}
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="close()">
      {{ 'FreeswitchIntegration::Cancel' | abpLocalization }}
    </button>
    <button type="button" class="btn btn-primary" [disabled]="!canExecute" (click)="execute()">
      {{ 'FreeswitchIntegration::ConsoleExecute' | abpLocalization }}
    </button>
  </ng-template>
</p-dialog>
